import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentMethodGet } from '../../../../core/interfaces/payment-interfaces';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { CardlogoComponent } from "../cardlogo/cardlogo.component";

@Component({
  selector: 'app-payment-card',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, CardlogoComponent],
  templateUrl: './payment-card.component.html',
  styleUrl: './payment-card.component.css'
})
export class PaymentCardComponent {
  @Input() paymentMethod: PaymentMethodGet | undefined = undefined;
  @Output() paymentSetAsDefault = new EventEmitter<PaymentMethodGet>();
  @Output() deletePaymentMethod = new EventEmitter<PaymentMethodGet>();

  setAsDefaultClick(): void {
    if (this.paymentMethod) {
      this.paymentSetAsDefault.emit(this.paymentMethod);
    }
  }

  deleteClick(): void {
    if (this.paymentMethod) {
      this.deletePaymentMethod.emit(this.paymentMethod);
    }
  }
}
